/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ItemOrQuantityInternationalFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { ItemOrQuantityIssueTypeInternational } from '@cod-monorepo/interfaces';
import { tap } from 'rxjs';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine } from '../../../state/cod.action';
import { BaseInternationalStep } from '../base-international-step/base-international-step';

@Component({
    selector: 'app-cod-item-or-quantity-international-step',
    templateUrl: './item-or-quantity-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent
    ],
    standalone: true
})
export class CodItemOrQuantityInternationalStepComponent extends BaseInternationalStep implements OnInit {
    @Input() itemOrQuantityInternationalForm: FormGroup<ItemOrQuantityInternationalFormGroup> | undefined;

    public itemOrQuantityDiscrepancies = ItemOrQuantityIssueTypeInternational;

    public showFinancialAdjustment = false;
    public showRelatedDocuments = false;

    constructor(private store: Store) {
        super();
    }

    ngOnInit(): void {
        this.initChangesListener();
    }

    public evaluate(): void {
        const controls = this.itemOrQuantityInternationalForm?.controls;
        const issueType = controls?.issueType.value;
        const communicationDeclinedDocuments = controls?.communicationDeclinedDocuments.value ?? [];
        const canIdentifyCartonId = controls?.canIdentifyCartonId.value;
        const lotsDeclinedWithin24Hours = controls?.lotsDeclinedWithin24Hours.value;
        const financialAdjustmentRequested = controls?.financialAdjustment.value;

        if (
            issueType === ItemOrQuantityIssueTypeInternational.WRONG_BATCH_SHIPPED ||
            issueType === ItemOrQuantityIssueTypeInternational.WRONG_SERIAL_SHIPPED
        ) {
            if (lotsDeclinedWithin24Hours) {
                this.showFinancialAdjustment = communicationDeclinedDocuments.length > 0;
                this.showRelatedDocuments = communicationDeclinedDocuments.length > 0;
            }

            if (lotsDeclinedWithin24Hours === false) {
                this.showRelatedDocuments = true;
            }

            return;
        }

        if (issueType === ItemOrQuantityIssueTypeInternational.WRONG_SMN_SHIPPED) {
            this.showRelatedDocuments = canIdentifyCartonId !== null;
            this.showFinancialAdjustment = false;
            return;
        }

        this.showFinancialAdjustment = canIdentifyCartonId !== null;
        this.showRelatedDocuments = !!financialAdjustmentRequested;
        return;
    }

    public handleConfirm() {
        if (this.itemOrQuantityInternationalForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.itemOrQuantityInternationalForm?.valid ?? false;
    }

    private initChangesListener(): void {
        this.itemOrQuantityInternationalForm?.valueChanges
            .pipe(
                tap(() => {
                    this.evaluate();
                })
            )
            .subscribe();
    }
}
